
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M2.344 13.656A7.942 7.942 0 008 16a7.937 7.937 0 005.656-2.344A7.942 7.942 0 0016 8a7.937 7.937 0 00-2.344-5.656A7.937 7.937 0 008 0a7.937 7.937 0 00-5.656 2.344A7.937 7.937 0 000 8c0 2.137.831 4.147 2.344 5.656zM7 4a.999.999 0 112 0v5a.999.999 0 11-2 0V4zm2 8a.999.999 0 10-2 0 .999.999 0 102 0z","clip-rule":"evenodd"}})])
          )
        }
      }
    